import { Injectable, Injector, signal } from '@angular/core';
import { Cruise } from 'src/app/core/models/cruise';
import { CompanyParamsService } from '../../../core/services/company-params.service';
import { SearchService } from '../../../shared/services/search.service';
import { Availability } from '../../../core/models/availability';
import { TipoPaqueteEcommerceEnum } from '../../../core/enums/type-package-ecommerce.enum';
import { PriceRateService } from './price-rate.service';
import { PriceRateDescriptor } from '../../../core/enums/price-rate-descriptor.enum';
import { DayPeriod } from '../../../core/models/day-period-model';
import { CabinaItinerarioMenor } from '../../../core/models/cabin/cabina-itinerario-menor';
import { CabinaItinerarioMenorWrapper } from '../../../core/classes/cabina-itinerario-menor-wrapper';
import { PassengerType } from '../../../core/enums/passenger-type.enum';
import { CabinService } from './cabin.service';
import { PromoCode } from '../../../core/enums/promo-code.enum';
import { BaseComponent } from 'src/app/shared/base/base.component';

@Injectable({
  providedIn: 'root',
})
export class CruiseServiceAux extends BaseComponent {
  cruises = signal<Cruise[]>([]);
  isSearching = signal(true);
  noMoreResult = false;
  totalPassengers = 0;
  public readonly CODIGO_GALAVEN = 203;
  priceResume = signal(0);
  wasPriceResume = signal(0);
  private cruiseSelected: Cruise | undefined;
  public readonly  MINIMUN_DEPARTURES_VIEW = 4;
  option='';

  constructor(
    private companyParamsService: CompanyParamsService,
    private searchService: SearchService,
    private priceRateService: PriceRateService,
    private cabinaService: CabinService,
    private  injector  : Injector,
  ) {
    super(injector);
  }

  addCruises(agency:string,cruises: Cruise[]) {
    cruises.forEach((itemCruise) => {
      itemCruise.viewDeparturesMinimun = itemCruise.availability.length <= this.MINIMUN_DEPARTURES_VIEW
      itemCruise.availability.forEach((itemAvailability) => {
        itemAvailability.favoriteFit=this.existsFavoriteInLocalStorage(agency,itemAvailability.code, 'fit');
        itemAvailability.favoriteCharter=this.existsFavoriteInLocalStorage(agency,itemAvailability.code, 'charter');
      });
    });
    this.cruises.update(current => [...current, ...cruises]);
  }

  getCruises(): Cruise[] {
    return this.cruises();
  }

  restartCruises() {
    this.cruises.set([]);
    this.isSearching.set(true);
    this.noMoreResult = false;
  }

  setIsSearching(status: boolean) {
    this.isSearching.set(status);
  }

  getIsSerching() {
    return this.isSearching();
  }

  setNoMoreResult(status: boolean) {
    this.noMoreResult = status;
  }

  getNoMoreResult() {
    return this.noMoreResult;
  }

  setCruiseSelected(cvalue: Cruise) {
    this.cruiseSelected = cvalue;
  }

  getCruiseSelected(): Cruise {
    return this.cruiseSelected ? this.cruiseSelected : this.getDefaultCruise();
  }

  public getIterDayAsString(cruise: any, iterIndex: number): string {
    let response = '';
    let auxIslandsName: any = [];
    const mystringkey = cruise.availability[iterIndex].name;
    cruise.itineraries.forEach((itemitenerary: any) => {
      const myotherkey = itemitenerary.name;
      if (mystringkey === myotherkey) {
        itemitenerary.days.map((v: any) => {
          const dataBundle: any = {};
          dataBundle.diaSemana = v.name;
          dataBundle.morningActivities = [];
          dataBundle.afternoonActivities = [];
          v.schedules.map((e: any) => {
            e.activities.forEach((activity: any) => {
              let valueName = activity.name;
              if (activity.name === 'Island') {
                valueName = activity.description;
              }
              const index = auxIslandsName.findIndex(
                (nameIs: string) => nameIs === valueName
              ); // it is using to search name islands
              if (index < 0) {
                auxIslandsName.push(valueName);
                response = response + valueName + ', ';
              }
            });
          });
        });
      }
    });
    return response;
  }

  calculatePrice(price: number, percents: any[], packageCode: any) {
    const agencyPercent: number = this.isNullOrUndefined(
      this.getAgencyPercent(percents, packageCode)
    )
      ? 0
      : this.getAgencyPercent(percents, packageCode) / 100;
    return Math.floor(price - price * agencyPercent);
  }
  calculatePriceWithPackage(
    price: number,
    percents: any[],
    packageCode: any,
    isSeletedGBCPackage: boolean
  ) {
    const agencyPercent: number = this.isNullOrUndefined(
      this.getAgencyPercent(percents, packageCode)
    )
      ? 0
      : this.getAgencyPercent(percents, packageCode) / 100;
    const ticketValue =
      Number(packageCode) === 1999
        ? isSeletedGBCPackage
          ? 0
          : this.getAdultAirFare()
        : 0;
    return Math.floor(
      price - price * agencyPercent + (ticketValue ? ticketValue : 0)
    );
  }
  public getAgencyPercent(percents: any, packageCode: any): number {
    // return null; // it is for use prices machine always, delete it if you want to use arrays percents
    try {
      if (percents.length !== 0) {
        // with my flag diferentA_B set type_B for get percent of array
        if (percents.length === 1) {
          return Number(atob(percents[0].value));
        }

        // find package code
        let valPercentObj = percents.find(
          (percent: any) => Number(percent.packageCode) === Number(packageCode)
        );
        if (this.isNullOrUndefined(valPercentObj)) {
          valPercentObj = percents.find(
            (percent: any) =>
              percent.packageCode === TipoPaqueteEcommerceEnum.TYPE_A_B
          );
        }
        if (this.isNullOrUndefined(valPercentObj)) {
          valPercentObj = percents.find(
            (percent: any) =>
              percent.packageCode === TipoPaqueteEcommerceEnum.TYPE_DEFAULT
          );
        }
        if (this.isNullOrUndefined(valPercentObj)) {
          valPercentObj = percents.find(
            (percent: any) =>
              percent.packageCode === TipoPaqueteEcommerceEnum.TYPE_B
          );
        }
        if (this.isNullOrUndefined(valPercentObj)) {
          valPercentObj = percents.find(
            (percent: any) =>
              percent.packageCode === TipoPaqueteEcommerceEnum.TYPE_A
          );
        }

        if (this.isNullOrUndefined(valPercentObj)) {
          return 0;
        }
        return Number(atob(valPercentObj.value));
      } else {
        return 0;
      }
    } catch (error) {
      return 0;
    }
  }

  validateBookNowButton(cruise: Cruise, iterIndex: number) {
    this.totalPassengers =
      Number(this.searchService.getRequestFindAvail().adults) +
      Number(this.searchService.getRequestFindAvail().children);
    let availability: Availability = cruise.availability[iterIndex];
    if (availability.charterOnly) {
      return this.totalPassengers === cruise.passengers;
    } else if (availability.groupsOnly) {
      return this.totalPassengers >= cruise.minimumGroupOnly;
    } else {
      return true;
    }
  }

  validateBookNowButtonFavorites(cruise:Cruise,availability: Availability) {
    this.totalPassengers =
      Number(this.searchService.getRequestFindAvail().adults) +
      Number(this.searchService.getRequestFindAvail().children);
    if (availability.charterOnly) {
      return this.totalPassengers === cruise.passengers;
    } else if (availability.groupsOnly) {
      return this.totalPassengers >= cruise.minimumGroupOnly;
    } else {
      return true;
    }
  }

  validationWithAvail(cruise: Cruise, iterIndex: number) {
    this.totalPassengers =
      Number(this.searchService.getRequestFindAvail().adults) +
      Number(this.searchService.getRequestFindAvail().children);
    let availability: Availability = cruise.availability[iterIndex];
    return Number(availability.avail) >= this.totalPassengers;
  }

  validationWithAvailFavorites(availability: Availability) {
    this.totalPassengers =
      Number(this.searchService.getRequestFindAvail().adults) +
      Number(this.searchService.getRequestFindAvail().children);
     return Number(availability.avail) >= this.totalPassengers;
  }

  isNullOrUndefined(value: any) {
    return value === null || value === undefined;
  }
  public createIterDay(cruise: any): {}[] {
    const AllItinerary: any[] = [];
    const mystringkey = cruise.availability[cruise.iterIndex]?.itinerary;
    cruise.itineraries.forEach((itemitenerary: any) => {
      const myotherkey = itemitenerary.code;
      if (mystringkey === myotherkey) {
        itemitenerary.days.map((v: any) => {
          const dataBundle: any = {};
          dataBundle.diaSemana = v.name;
          dataBundle.morningActivities = [];
          dataBundle.afternoonActivities = [];
          v.schedules.map((e: any) => {
            e.activities.forEach((activity: any) => {
              if (e.type === DayPeriod.AM) {
                dataBundle.morningActivities.push({
                  optional: activity.optional,
                  isla: activity.name,
                  period: e.type,
                  nombre: activity.description,
                });
              } else {
                dataBundle.afternoonActivities.push({
                  optional: activity.optional,
                  isla: activity.name,
                  period: e.type,
                  nombre: activity.description,
                });
              }
            });
          });
          AllItinerary.push(dataBundle);
        });
      }
    });
    return AllItinerary;
  }

  public createIterDescription(cruise: any): any {
    let iterDescription: any = "";
    const mystringkey = cruise.availability[cruise.iterIndex]?.itinerary;
    cruise.itineraries.forEach((itemitenerary: any) => {
      const myotherkey = itemitenerary.code;
      if (mystringkey === myotherkey) {
        iterDescription = itemitenerary.description;
      }
    });
    return iterDescription;
  }

  public createIterDayByItinerary(itinerary: any): {}[] {
    const AllItinerary: any[] = [];

      itinerary.days.map((v: any) => {
          const dataBundle: any = {};
          dataBundle.diaSemana = v.name;
          dataBundle.morningActivities = [];
          dataBundle.afternoonActivities = [];
          v.schedules.map((e: any) => {
            e.activities.forEach((activity: any) => {
              if (e.type === DayPeriod.AM) {
                dataBundle.morningActivities.push({
                  optional: activity.optional,
                  isla: activity.name,
                  period: e.type,
                  nombre: activity.description,
                });
              } else {
                dataBundle.afternoonActivities.push({
                  optional: activity.optional,
                  isla: activity.name,
                  period: e.type,
                  nombre: activity.description,
                });
              }
            });
          });
          AllItinerary.push(dataBundle);
        });
    return AllItinerary;
  }

  public createDescriptionByItinerary(itinerary: any): {}[] {
    return itinerary.description;
  }


  calculatePricetoForm(
    price: number,
    percents: any[],
    packageCode: any,
    isSeletedGBCPackage: boolean
  ) {
    const agencyPercent: number = this.isNullOrUndefined(
      this.getAgencyPercent(percents, packageCode)
    )
      ? 0
      : this.getAgencyPercent(percents, packageCode) / 100;
    const ticketValue =
      Number(packageCode) === 1999
        ? isSeletedGBCPackage
          ? 0
          : this.getAdultAirFare()
        : 0;

    return Math.floor(
      price - price * agencyPercent + (ticketValue ? ticketValue : 0)
    );
  }
  getAdultAirFare() {
    return this.priceRateService.getPriceRateByName(PriceRateDescriptor.AirFare)
      ?.valor;
  }

  calculateRackPrice(
    price: number,
    packageCode: any,
    isSeletedGBCPackage: any
  ) {
    try {
      const ticketValue =
        Number(packageCode) === 1999
          ? isSeletedGBCPackage
            ? 0
            : this.getAdultAirFare()
          : 0;
      return Math.floor(price + (ticketValue ? ticketValue : 0));
    } catch (error) {
      return 0;
    }
  }

  getDefaultCruise(): Cruise {
    return {
      availability: [],
      beam: '',
      category: 0,
      categoryII: '',
      code: 0,
      description: '',
      draft: '',
      image: '',
      imageCard: '',
      images: [],
      itineraryTypes: [],
      keyFeatures: [],
      lenght: '',
      maximumAgeChild: 0,
      minimumAgeChild: 0,
      mostAffordableDeparture: 0,
      name: '',
      overview:'',
      passengers: 0,
      speed: '',
      type: '',
      year: 0,
      iterIndex: 0,
      logo: '',
      pathFriendly: '',
      comments: [],
      mainComment: 0,
      accommodationRating: 0,
      serviceRating: 0,
      webLink: '',
      userCode: '',
      recommended: false,
      minimumGroupOnly: 0,
      deckPlanImages: [],
      length: '',
      viewDepartures: false,
      viewDeparturesMinimun : false,
      activatedRating: false,
      activatedShare:false,
      activatedReviews:false
    };
  }
  public getCruisePriceinNewFormat(
    cruise: Cruise,
    selectedItinerary: number,
    includeAirFare: boolean,
    packageCode: number
  ): number {
    try {
      // const mycode = cruise.mostAffordableDeparture
      const availMenor: CabinaItinerarioMenor = {
        code: cruise.availability[selectedItinerary].code,
        rackPrice: cruise.availability[selectedItinerary].rackPrice,
        promotionType: cruise.availability[selectedItinerary].promotionType,
        promotionCode: cruise.availability[selectedItinerary].promotionCode,
        promotionPrice: cruise.availability[selectedItinerary].promotionPrice,
        promotionPublic: cruise.availability[selectedItinerary].promotionPublic,
        percents: cruise.availability[selectedItinerary].percents,
        sglPercent: cruise.availability[selectedItinerary].sglPercent,
        packageCode,
        packageGBCCode: cruise.availability[selectedItinerary].packageGBCCode,
      };

      const cabinaItinerarioMenorWrapper: CabinaItinerarioMenorWrapper =
        new CabinaItinerarioMenorWrapper(availMenor);

      return cabinaItinerarioMenorWrapper.getAppPrice(
        cruise.category,
        includeAirFare,
        false,
        PassengerType.ADULT,
        this.cabinaService
      );
    } catch (error) {
      return 0;
    }
  }

  public includesFreeTransfers(
    cruise: Cruise,
    selectedItinerary: number,
    isIncludeAirFare: boolean
  ): boolean {
    try {
      const promoCode: number =
        cruise.availability[selectedItinerary].promotionType;
      return (
        (cruise.category === 4 || cruise.category === 5) &&
        isIncludeAirFare === true &&
        (promoCode === PromoCode.PROMO_RAC ||
          promoCode === PromoCode.PROMO_OFF) &&
        cruise.code !== this.CODIGO_GALAVEN
      );
    } catch (error) {
      console.error(error);
      throw error;
    }
  }
  setWasPrice(value: number) {
    this.wasPriceResume.set(value);
  }
  setPrice(value: number) {
    this.priceResume.set(value);
  }

  getWasPrice() {
    return this.wasPriceResume();
  }
  getPrice() {
    return this.priceResume();
  }

  public doesItineraryHasPromo(
    cruise: Cruise,
    itineraryIndex: number
  ): boolean {
    try {
      return (
        !this.isNullOrUndefined(
          cruise.availability[itineraryIndex].promotionType
        ) &&
        cruise.availability[itineraryIndex].promotionType !==
          PromoCode.PROMO_RAC
      );
    } catch (error) {
      return false;
    }
  }

  setOption(value:string){
    this.option = value;
  }

  getOption(){
    return this.option;
  }

}
